var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 353.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e7e8e3;}.cls-2{fill:#364a5e;}.cls-3{fill:#fff;}.cls-4{fill:#202121;opacity:0.15;isolation:isolate;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M512,322.83a30.27,30.27,0,0,1-30.27,30.27H30.26A30.27,30.27,0,0,1,0,322.83V30.27A30.26,30.26,0,0,1,30.26,0H481.73A30.27,30.27,0,0,1,512,30.27V322.83Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 68.68,
    width: 512,
    height: 72.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 140.71,
    width: 512,
    height: 44.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M21.52,322.83V30.27A30.26,30.26,0,0,1,51.78,0H30.26A30.26,30.26,0,0,0,0,30.27V322.83A30.26,30.26,0,0,0,30.26,353.1H51.78A30.27,30.27,0,0,1,21.52,322.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M160.06,243.27H55.44a8.35,8.35,0,1,1,0-16.69H160.06a8.35,8.35,0,1,1,0,16.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M160.06,278H55.44a8.35,8.35,0,1,1,0-16.69H160.06a8.35,8.35,0,1,1,0,16.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M160.06,312.67H55.44a8.35,8.35,0,0,1,0-16.7H160.06a8.35,8.35,0,0,1,0,16.7Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.eae6c5b94608ec9d7ea50b995b08ab0f.svg";
export { ForwardRef as ReactComponent };